import { Injectable } from "@angular/core";
import { HttpParams } from "@angular/common/http";

@Injectable({
    providedIn: "root",
})
export class UtilityService {
    //#region  Methods

    downloadFile(baseUrl: string, params: HttpParams) {
        const a = document.createElement("a");
        a.setAttribute("style", "display:none;");
        document.body.appendChild(a);
        a.href = `${baseUrl}?${params.toString()}`;
        a.target = "_self";
        a.click();
        a.onloadstart = () => console.log('link download start');
        document.body.removeChild(a);
    }
    //#endregion
}
